// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearVideoVertical = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.89062 22.23C6.48063 22.23 6.14062 21.89 6.14062 21.48V2.52002C6.14062 2.11002 6.48063 1.77002 6.89062 1.77002C7.30062 1.77002 7.64062 2.10002 7.64062 2.52002V21.48C7.64062 21.9 7.30062 22.23 6.89062 22.23Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.8906 22.23C16.4806 22.23 16.1406 21.89 16.1406 21.48V2.52002C16.1406 2.11002 16.4806 1.77002 16.8906 1.77002C17.3006 1.77002 17.6406 2.11002 17.6406 2.52002V21.48C17.6406 21.9 17.3006 22.23 16.8906 22.23Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.88906 7.72021H2.53906C2.12906 7.72021 1.78906 7.38021 1.78906 6.97021C1.78906 6.56021 2.12906 6.22021 2.53906 6.22021H6.88906C7.29906 6.22021 7.63906 6.56021 7.63906 6.97021C7.63906 7.38021 7.29906 7.72021 6.88906 7.72021Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.8893 12.75H2.0293C1.6193 12.75 1.2793 12.41 1.2793 12C1.2793 11.59 1.6193 11.25 2.0293 11.25H6.8893C7.2993 11.25 7.6393 11.59 7.6393 12C7.6393 12.41 7.2993 12.75 6.8893 12.75Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.89047 17.7202H2.48047C2.07047 17.7202 1.73047 17.3802 1.73047 16.9702C1.73047 16.5602 2.07047 16.2202 2.48047 16.2202H6.89047C7.30047 16.2202 7.64047 16.5602 7.64047 16.9702C7.64047 17.3802 7.30047 17.7202 6.89047 17.7202Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.8891 7.72021H17.5391C17.1291 7.72021 16.7891 7.38021 16.7891 6.97021C16.7891 6.56021 17.1291 6.22021 17.5391 6.22021H21.8891C22.2991 6.22021 22.6391 6.56021 22.6391 6.97021C22.6391 7.38021 22.2991 7.72021 21.8891 7.72021Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.8893 12.75H17.0293C16.6193 12.75 16.2793 12.41 16.2793 12C16.2793 11.59 16.6193 11.25 17.0293 11.25H21.8893C22.2993 11.25 22.6393 11.59 22.6393 12C22.6393 12.41 22.2993 12.75 21.8893 12.75Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.9707 12.75H5.9707C5.5607 12.75 5.2207 12.41 5.2207 12C5.2207 11.59 5.5607 11.25 5.9707 11.25H16.9707C17.3807 11.25 17.7207 11.59 17.7207 12C17.7207 12.41 17.3907 12.75 16.9707 12.75Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.8905 17.7202H17.4805C17.0705 17.7202 16.7305 17.3802 16.7305 16.9702C16.7305 16.5602 17.0705 16.2202 17.4805 16.2202H21.8905C22.3005 16.2202 22.6405 16.5602 22.6405 16.9702C22.6405 17.3802 22.3005 17.7202 21.8905 17.7202Z',
      fill: 'currentColor',
    }),
  );

export { IconLinearVideoVertical };
